import React from 'react';

export const useEffectAfterMount = (cb: any, dependencies: any) => {
  const justMounted = React.useRef(true);
  // eslint-disable-next-line consistent-return
  React.useEffect(() => {
    if (!justMounted.current) {
      return cb();
    }
    justMounted.current = false;
  }, dependencies);
};
